module.exports = __webpack_public_path__ + "img/analysis_subjective_top_white.bfbff7e0.svg";